import { IModal, IToast, TradeCommentType, IError } from '@shared/models';
import { settings } from '@configs';

export interface State {
  modals: {
    [id: string]: IModal
  };
  toasts: {
    [id: string]: IToast
  };
  filters: {
    feed: TradeCommentType
  };
  forms: {
    [id: string]: {
      loading: boolean;
      data: any;
      error: IError
    };
  };
}

export const initialState: State = {
  modals: null,
  toasts: null,
  filters: {
    feed: null
  },
  forms: {
    [settings.forms.userBlocksBalanceFormId]: {
      loading: false,
      data: null,
      error: null
    },
    [settings.forms.declineOrgFormId]: {
      loading: false,
      data: null,
      error: null
    }
  }
};
